import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'color',
  title: 'Vehicle Colors',
  type: 'document',
  orderings: [
    {
      title: 'Name A-Z',
      name: 'nameAsc',
      by: [{field: 'name', direction: 'asc'}],
    },
  ],
  fields: [
    defineField({
      name: 'name',
      title: 'Name',
      type: 'string',
      validation: (rule) => rule.required(),
    }),
    defineField({
      name: 'slug',
      title: 'Slug',
      type: 'slug',
      description:
        'Vehicle Color does not have dedicated page on the frontend. We are using this slug to generate URLs for the gallery pages filter ie. `?color=red`.',
      validation: (rule) => rule.required(),
      options: {
        source: 'name',
        maxLength: 50,
      },
    }),
  ],
})